<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/plugins']" appearance="plain" variant="neutral">Back to Plugins</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>RabbitMQ Comms</h1>
					<p waBody="m" waText>Bidirectional browser-to-server messaging via RabbitMQ &mdash; WebSocket/STOMP bridge, group-based pub/sub, Angular directive integration, session-aware channels, automatic reconnection, and SockJS fallback. Connects Angular browser clients to RabbitMQ message broker for real-time push notifications and live updates.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">RabbitMQ 3.x</wa-tag>
						<wa-tag pill variant="neutral">Vert.x 5</wa-tag>
						<wa-tag pill variant="neutral">STOMP</wa-tag>
						<wa-tag pill variant="neutral">WebSocket</wa-tag>
						<wa-tag pill variant="neutral">Angular 21</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp:jwebmp-rabbitmq</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.rabbit</p>
					<p waBody="s" waText>Built on: RabbitMQ / STOMP.js / SockJS 3.x</p>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>INSTALLATION</div>
					<div class="code-block-wrapper">
						<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
						<markdown [data]="mdContent_114" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
					<div class="code-block-wrapper">
						<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
						<markdown [data]="mdContent_115" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>FEATURES</div>
					<p waBody="s" waColorText="quiet" waText>Real-time browser communication &mdash; WebSocket-based bidirectional messaging</p>
					<p waBody="s" waColorText="quiet" waText>STOMP protocol &mdash; industry-standard STOMP over WebSocket with heartbeat support</p>
					<p waBody="s" waColorText="quiet" waText>Group-based pub/sub &mdash; dynamic subscription management with RabbitMQ fanout exchanges</p>
					<p waBody="s" waColorText="quiet" waText>Angular directive integration &mdash; &#91;data-rabbit-groups&#93; attribute for automatic group subscription</p>
					<p waBody="s" waColorText="quiet" waText>Automatic exchange management &mdash; server-side declaration and lifecycle via Vert.x RabbitMQ client</p>
					<p waBody="s" waColorText="quiet" waText>Session-aware messaging &mdash; automatic subscription to session-specific groups</p>
					<p waBody="s" waColorText="quiet" waText>Connection resilience &mdash; automatic reconnection with configurable delays and state observables</p>
					<p waBody="s" waColorText="quiet" waText>Server-side WebSocket hooks &mdash; onAddToGroup, onRemoveFromGroup, onPublish lifecycle events</p>
					<p waBody="s" waColorText="quiet" waText>TypeScript client generation &mdash; fully typed Angular provider and directive</p>
					<p waBody="s" waColorText="quiet" waText>SockJS fallback &mdash; graceful degradation for proxies without native WebSocket</p>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-m">
					<div waCaption="s" waFontWeight="semibold" waText>EXAMPLES</div>
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>Module Setup</h4>
						<p waBody="s" waColorText="quiet" waText>Configure RabbitMQ in your module-info.java.</p>
						<markdown [data]="mdContent_116" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>Angular Directive Usage</h4>
						<p waBody="s" waColorText="quiet" waText>Subscribe to RabbitMQ groups from Angular templates.</p>
						<markdown [data]="mdContent_117" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>QUICK START</div>
					<markdown [data]="mdContent_118" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-s">
					<div waCaption="s" waFontWeight="semibold" waText>SPI EXTENSION POINT DETAILS</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">IPageConfigurator</wa-tag>
							<wa-tag pill variant="neutral">provides</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>RabbitMQPageConfigurator registers STOMP client scripts and Angular directive</p>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">IGuiceModule</wa-tag>
							<wa-tag pill variant="neutral">provides</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Registers RabbitMQ Vert.x client and exchange management bindings</p>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">IGuiceScanModuleInclusions</wa-tag>
							<wa-tag pill variant="neutral">provides</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Ensures RabbitMQ packages are included in Guice scanning</p>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>SPI EXTENSION POINTS</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="success">provides IPageConfigurator</wa-tag>
						<wa-tag pill variant="success">provides IGuiceModule</wa-tag>
						<wa-tag pill variant="success">provides IGuiceScanModuleInclusions</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-s">
					<div waCaption="s" waFontWeight="semibold" waText>CONFIGURATION</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<h4 waHeading="s" waText>RABBITMQ&#95;HOST</h4>
							<wa-tag pill variant="neutral">String</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>RabbitMQ server hostname</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Default: localhost</div>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<h4 waHeading="s" waText>RABBITMQ&#95;PORT</h4>
							<wa-tag pill variant="neutral">int</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>RabbitMQ AMQP port</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Default: 5672</div>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<h4 waHeading="s" waText>RABBITMQ&#95;WEB&#95;STOMP&#95;PORT</h4>
							<wa-tag pill variant="neutral">int</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>RabbitMQ Web STOMP port for browser connections</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Default: 15674</div>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<h4 waHeading="s" waText>RABBITMQ&#95;USERNAME</h4>
							<wa-tag pill variant="neutral">String</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>RabbitMQ authentication username</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Default: guest</div>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<h4 waHeading="s" waText>RABBITMQ&#95;PASSWORD</h4>
							<wa-tag pill variant="neutral">String</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>RabbitMQ authentication password</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Default: guest</div>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>PREREQUISITES</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
						<wa-tag pill variant="neutral">Node.js 18+</wa-tag>
						<wa-tag pill variant="neutral">Angular 21+</wa-tag>
						<wa-tag pill variant="neutral">RabbitMQ Server</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://www.rabbitmq.com/</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/RabbitMQ</wa-tag>
				</div>
			</div>
		</wa-card>
	</div>
</div>